/**
 * Localized weekday names via Intl. Preferred over the date-fns locale
 * registry (src/plugins/date-fns-locales.ts) because Intl is synchronous —
 * the registry loads locale chunks async and may not be populated at first
 * render — and it covers every supported UI language (date-fns lacks ur).
 */

/** Abbreviated weekday name of `date` in the given locale (e.g. "lun."). */
export function shortWeekday(locale: string, date: Date): string {
  return new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(date);
}

/**
 * The 7 abbreviated weekday names, Monday-first, in the given locale.
 * Built from fixed UTC reference dates (2024-01-01 was a Monday) and
 * formatted in UTC so the local timezone can never shift the day.
 */
export function shortWeekdaysMonFirst(locale: string): string[] {
  const formatter = new Intl.DateTimeFormat(locale, {
    weekday: 'short',
    timeZone: 'UTC',
  });
  return Array.from({ length: 7 }, (_, i) =>
    formatter.format(new Date(Date.UTC(2024, 0, 1 + i)))
  );
}
